class PolicyDirective {
  static directive() {
    return {
      replace:true,
      template: `
        <div class="policy md-caption">
          <a ui-sref="public.users.policy">{{ 'USERS.POLICY' | translate }}</a>
          <p><a href="https://www.fhome.pl" target="_blank">{{ 'USERS.COPYRIGHT' | translate }}</a></p>
        </div>
      `
    }
  };
}

export default PolicyDirective.directive;


// WEBPACK FOOTER //
// ./src/users/directives/policy.js